import CityPageTemplate from "../city-template/CityPageTemplate";
import { dublinConfig } from "./data";

export default function DublinPage() {
  return <CityPageTemplate config={dublinConfig} />;
}